
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <article className="grid md:grid-cols-2 gap-8 lg:gap-12 items-center mb-16">
          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://static.readdy.ai/image/8a088853fb554840745d180bcc58d87d/751fe7cc5fe7b284952641919d28d4a8.jpeg"
                alt="Trey and Nichole Wright"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="bg-gray-50 rounded-2xl p-8 lg:p-10 shadow-lg hover:shadow-xl transition-shadow">
            <div className="space-y-6">
              <h3 className="text-2xl lg:text-3xl font-bold text-gray-900">Our Story</h3>
              <p className="text-base text-gray-700 leading-relaxed">
                We understand the unique challenges small businesses face because we've been there. After years of building and scaling our own ventures, we discovered that success isn't just about tactics—it's about building on a foundation of purpose, integrity, and service.
              </p>
              <p className="text-base text-gray-700 leading-relaxed">
                Providence Path was born from our desire to share what we've learned and help other business owners create sustainable growth while staying true to their values. We believe that when you align your business with your faith and serve your customers with excellence, success naturally follows.
              </p>

              <div className="grid grid-cols-2 gap-4 pt-4">
                <div className="text-center p-6 bg-white rounded-xl shadow-md">
                  <div className="text-3xl font-bold text-teal-600 mb-2">25+</div>
                  <div className="text-sm text-gray-600">Years Combined Experience</div>
                </div>
                <div className="text-center p-6 bg-white rounded-xl shadow-md">
                  <div className="text-3xl font-bold text-teal-600 mb-2">40+</div>
                  <div className="text-sm text-gray-600">Businesses Helped</div>
                </div>
              </div>
            </div>
          </div>
        </article>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          <div className="text-center p-8 bg-gray-50 rounded-2xl hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-heart-line text-3xl text-teal-600"></i>
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3">Faith-Centered</h4>
            <p className="text-sm text-gray-600 leading-relaxed">
              We integrate Christian principles into every aspect of business growth, helping you build with purpose and integrity
            </p>
          </div>

          <div className="text-center p-8 bg-gray-50 rounded-2xl hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-line-chart-line text-3xl text-teal-600"></i>
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3">Proven Results</h4>
            <p className="text-sm text-gray-600 leading-relaxed">
              Our strategies are battle-tested and tailored for individual businesses looking to scale sustainably
            </p>
          </div>

          <div className="text-center p-8 bg-gray-50 rounded-2xl hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-team-line text-3xl text-teal-600"></i>
            </div>
            <h4 className="text-xl font-bold text-gray-900 mb-3">Personal Touch</h4>
            <p className="text-sm text-gray-600 leading-relaxed">
              As a husband and wife team, we bring both business expertise and genuine care to every client relationship
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
